import { useRouter } from 'next/router';
import { createContext, FunctionComponent, ReactNode, useEffect, useState } from 'react';

import { getFirstQueryParam } from '@utilities/query';

export interface FeatureFlagContextState {
  columns: boolean;
  dragDrop: boolean;
  video: boolean;
}

export const FeatureFlagContext = createContext<FeatureFlagContextState>({
  columns: false,
  dragDrop: false,
  video: false
});

interface FeatureFlagContextProps {
  children: ReactNode;
}

export const FeatureFlagProvider: FunctionComponent<FeatureFlagContextProps> = ({ children }) => {
  const { query } = useRouter();

  const [columns, setColumns] = useState(false);
  const [dragDrop, setDragDrop] = useState(false);
  const [video, setVideo] = useState(false);

  useEffect(() => {
    if (getFirstQueryParam(query.columns) === 'true') {
      setColumns(true);
    } else {
      setColumns(false);
    }

    if (getFirstQueryParam(query.dragDrop) === 'true') {
      setDragDrop(true);
    } else {
      setDragDrop(false);
    }

    if (getFirstQueryParam(query.video) === 'true') {
      setVideo(true);
    } else {
      setVideo(false);
    }
  }, [query]);

  return (
    <FeatureFlagContext.Provider value={{ columns, dragDrop, video }}>
      {children}
    </FeatureFlagContext.Provider>
  );
};
